import React, { useEffect, useState } from 'react';
import { FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import { Row, Col, Card } from 'react-bootstrap';
import './NutritionalInsights.css';

const NutritionalInsights = ({ ruleResult, kitData, petName }) => {
    const [conditions, setConditions] = useState([]);
    const [expandedPanel, setExpandedPanel] = useState(null);

    useEffect(() => {

        const filteredConditions = Object.keys(ruleResult)
            .filter(key => key !== 'foodrecommendations' && key !== 'supplementrecommendations')
            .map(key => ruleResult[key]);

        // Sort so that "high" traits come first
        const sortedConditions = filteredConditions.sort((a, b) => {
            const aHigh = getTraitStatus(a);
            const bHigh = getTraitStatus(b);
            return bHigh - aHigh; // true > false, so high first
        });

        setConditions(sortedConditions);
    }, [ruleResult]);

    const getTraitStatus = (condition) => {
        const value = condition?.Results?.[0]?.variable1_value?.toLowerCase();
        return value === 'high';
    };

    const getOrderedKeys = (isHigh) => {
        return isHigh ? ['Results', 'Description', 'Recommendations'] : ['Description'];
    };

    const togglePanel = (index) => {
        setExpandedPanel(prev => (prev === index ? null : index));
    };

    const trueCount = conditions.filter(getTraitStatus).length;

    return (
        <div className='report-card-container'>
            <Row className="justify-content-center">
                <div className="heading">Nutrition Insights</div>
            </Row>

            <Row className="justify-content-center" style={{ marginTop: '10px' }}>
                <div style={{ textAlign: 'center', fontSize: '24px', color: "black", fontWeight: "bold" }}>
                    {petName} has <span className='h-color'>{trueCount}</span> Nutrition Trait(s) of the {conditions.length} we analyzed.
                </div>
            </Row>


            <div
                className="d-flex justify-content-center"
                style={{ margin: "0 auto", maxWidth: "800px", flexWrap: "wrap", textAlign: "center" }}
            >
                <div style={{ width: "100%" }}>
                    Polygenic risk score (PRS) is a scientific method that combines information
                    from multiple genetic variants. Each variant contributes a small effect, and
                    together they provide a more accurate estimate of your dog’s genetic
                    predisposition for certain traits.
                </div>
            </div>

            <div
                className="d-flex justify-content-center pt-4"
                style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}
            >
                <div style={{ width: "100%" }}>
                    {petName} may have potential nutrient gaps in the following areas:
                </div>
            </div>


            <Row style={{ marginTop: '10px' }}>
                <div>
                    {conditions.map((condition, index) => {
                        const isHigh = getTraitStatus(condition);
                        const displayName = condition.DisplayName?.[0]?.result1_value || 'N/A';
                        if (displayName == 'N/A') return null;
                        return (
                            <div key={index}>
                                <Row
                                    style={{ margin: '10px 0', alignItems: 'center', cursor: 'pointer', marginLeft: "-50px" }}
                                    onClick={() => togglePanel(index)}
                                >
                                    <Col xs={3}></Col>
                                    <Col xs={7} className="row trait-col">
                                        <div style={{ alignItems: "center" }}>
                                            <span style={{ fontSize: 22, fontWeight: 'bold', width: '90%' }}>
                                                {displayName}
                                            </span>
                                            <span
                                                className='variant-parent'
                                                style={{ background: isHigh ? '#09718c' : null }}
                                            >
                                                {isHigh ? <FaTimesCircle size={30} /> : null}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>

                                {expandedPanel === index && (
                                    <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                                        <Card className='card-container'>
                                            <Card.Body>
                                                {getOrderedKeys(isHigh).map((key, subIndex) => (
                                                    condition[key] ? (
                                                        <div style={{ padding: "10px", marginBottom: '10px' }} key={subIndex}>
                                                            <div className="reportHeading h-color">{key}</div>
                                                            <span>
                                                                {Array.isArray(condition[key]) && condition[key].length > 0
                                                                    ? condition[key][0]?.result1_value
                                                                    : 'N/A'}
                                                            </span>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </Row>
        </div>
    );
};

export default NutritionalInsights;